import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { ContratosForm } from "../modais"
import Layout from "../Layout"
class ContratosCreateForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/contratos")
  }
  render() {
    return (
      <Layout tabActive="Contratos">
        <ContratosForm callBackContratos={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(ContratosCreateForm)



// WEBPACK FOOTER //
// ./src/views/contratos/ContratosCreateForm.js